export const hasSchedulingAlert = (requestedCount: number, suggestedCount: number): boolean => requestedCount + suggestedCount > 0
